

























































































































































































































import Vue from 'vue';
import Papa from 'papaparse';
import moment from 'moment';
import { TradeLogItem } from '@/models/TradeLogItem.ts';
import { ProfitLogItem } from '@/models/ProfitLogItem.ts';
import { KrakenLogItem } from '@/models/KrakenLogItem.ts';
import { BitstampLogItem } from '@/models/BitstampLogItem.ts';
import { CryptoProfitLog } from '@/models/CryptoProfitLog.ts';

let logFile: File;

export default Vue.extend({
  name: 'home',
  // components: {
  //   HelloWorld,
  // },
  data() {
    return {
      step: "intro",
      logType: "",
      tradeLog: new Array<TradeLogItem>(),
      showTradeLog: false,
      profitLog: <CryptoProfitLog>{},
      showCryptoProfitLog: new Array<boolean>(),
      profitLogCsv: "",
      showProfitLogCsv: false,
      errors: new Array<string>(),
      showErrorDetails: false,
      totalProfit: 0,
      totalCosts: 0,
      totalRevenue: 0
    }
  },
  methods: {
    goToLogStep: function() {
      this.step = 'logs';
    },

    processLog: function() {
      let fileInput = <HTMLInputElement>this.$refs.logFileInput;
      if (this.logType != "" && fileInput.files) {
        logFile = fileInput.files[0];
        switch(this.logType) {
          case "kraken": {
            this.parseKrakenLog();
            break;
          }
          case "bitstamp": {
            this.parseBitstampLog();
            break;
          }
        }
        (<HTMLInputElement>this.$refs.logFileInput).value = "";
        this.logType = "";

      }
    },

    parseKrakenLog: function() {
      //console.log(logFile);
      Papa.parse(logFile, {
          header: true,
          dynamicTyping: true,
          complete: (parsed) => {
            //console.log(parsed);

            if (parsed.errors && parsed.errors.length > 1) {
              alert(`Error processing file: ${parsed.errors[0].message} at row ${parsed.errors[0].row}`);
            }
            else if (parsed.errors &&
              parsed.errors[0].code == "TooFewFields" && parsed.errors[0].row == parsed.data.length - 1) // special case with empty string at the end
            {
              parsed.data.splice(parsed.data.length - 1);
              this.processKrakenLog(parsed.data);
            }
            else {
              this.processKrakenLog(parsed.data);
            }
          }
        }
      );
    },

    processKrakenLog(parsedLog: Array<KrakenLogItem>) {
      //console.log(parsedLog);

      parsedLog.forEach(item => {
        let operation = item.type.toUpperCase();

        if (operation == 'BUY' || operation == 'SELL') {
          let transactionId = item.txid;
          let timestamp = moment(item.time).toDate();
          let crypto = item.pair.length == 8 ? item.pair.substr(1, 3) : item.pair.substr(0, 3);
          crypto = crypto == 'XBT' ? 'BTC' : crypto;
          let fiat = item.pair.length == 8 ?  item.pair.substr(5, 3) : item.pair.substr(3, 3);
          let volume = item.vol;
          let price = operation == 'BUY' ? (item.cost + item.fee) / volume : (item.cost - item.fee) / volume;

          if (['EUR', 'USD', 'GBP'].indexOf(fiat) > -1) {
            this.tradeLog.push(new TradeLogItem(
              'kraken',
              transactionId,
              timestamp,
              crypto,
              operation,
              price,
              volume
            ));
          }
          else {
            this.errors.push(`Pair not supported: ${crypto}/${fiat}, volume: ${volume} on ${timestamp}`);
          }
        }
      });

      //console.log(this.tradeLog);
    },

    parseBitstampLog: function() {
      // console.log(logFile);
      Papa.parse(logFile, {
          header: true,
          dynamicTyping: true,
          complete: (parsed) => {
            //console.log(parsed);

            if (parsed.errors && parsed.errors.length > 1) {
              alert(`Error processing file: ${parsed.errors[0].message} at row ${parsed.errors[0].row}`);
            }
            else if (parsed.errors &&
              parsed.errors[0].code == "TooFewFields" && parsed.errors[0].row == parsed.data.length - 1) // special case with empty string at the end
            {
              parsed.data.splice(parsed.data.length - 1);
              this.processBitstampLog(parsed.data);
            }
            else {
              this.processBitstampLog(parsed.data);
            }
          }
        }
      );
    },

    processBitstampLog(parsedLog: Array<BitstampLogItem>) {
      //console.log(parsedLog);

      parsedLog.forEach(item => {
        if (item.Type == 'Market') {
          let operation = item["Sub Type"].toUpperCase();

          if (operation == 'BUY' || operation == 'SELL') {
            let timestamp = moment(item.Datetime, 'MMM. DD, YYYY, hh:mm A').toDate();
            let transactionId = moment(timestamp).format('YYYYMMDDHHmmss');
            let crypto = item.Amount.substr(item.Amount.length - 3, 3);
            let volume = parseFloat(item.Amount.substr(0, item.Amount.length - 4));
            let fee = item.Fee.length > 4 ? parseFloat(item.Fee.substr(0, item.Fee.length - 4)) : 0;
            let value = parseFloat(item.Value.substr(0, item.Value.length - 4));
            let price = operation == 'BUY' ? (value + fee) / volume : (value - fee) / volume;

            this.tradeLog.push(new TradeLogItem(
              'bitstamp',
              transactionId,
              timestamp,
              crypto,
              operation,
              price,
              volume
            ));
          }
        }
      });

      //console.log(this.tradeLog);
    },



    calculatePnL: function() {
      this.step = "results";

      this.tradeLog.sort((a, b) => { return (a.timestamp < b.timestamp ? -1 : 1) });

      // get all currencies
      let cryptos = new Array<string>();
      this.tradeLog.forEach(trade => {
        if (cryptos.indexOf(trade.crypto) === -1) {
          cryptos.push(trade.crypto);
        }
      });

      

      cryptos.forEach(crypto => {
        let cryptoBuyLog = this.tradeLog.filter((trade) => { return trade.crypto === crypto && trade.operation === 'BUY' });
        let cryptoSellLog = this.tradeLog.filter((trade) => { return trade.crypto === crypto && trade.operation === 'SELL' });
        
        this.profitLog[crypto] = new Array<ProfitLogItem>();

        cryptoSellLog.forEach(sale => {
          while (cryptoBuyLog[0] && sale.volume > cryptoBuyLog[0].volume) {
            this.profitLog[crypto].push(new ProfitLogItem(
              sale.timestamp,
              sale.crypto,
              cryptoBuyLog[0].platform,
              cryptoBuyLog[0].transactionId,
              cryptoBuyLog[0].price,
              sale.platform,
              sale.transactionId,
              sale.price,
              cryptoBuyLog[0].volume,
              (sale.price - cryptoBuyLog[0].price) * cryptoBuyLog[0].volume
            ));

            sale.volume -= cryptoBuyLog[0].volume;

            cryptoBuyLog.shift();
          }

          let lastPrice = 0;
          let lastBuyPlatform = "-";
          let lastBuyTransactionId = "-";
          if (cryptoBuyLog[0]) {
            lastPrice = cryptoBuyLog[0].price;
            lastBuyPlatform = cryptoBuyLog[0].platform;
            lastBuyTransactionId = cryptoBuyLog[0].transactionId;
          }
          else {
            this.errors.push(`Sell without buy: ${sale.crypto} on ${sale.timestamp}, unaccounted volume: ${sale.volume} at ${sale.price} logged as profit`);
          }
          this.profitLog[crypto].push(new ProfitLogItem(
              sale.timestamp,
              sale.crypto,
              lastBuyPlatform,
              lastBuyTransactionId,
              lastPrice,
              sale.platform,
              sale.transactionId,
              sale.price,
              sale.volume,
              (sale.price - lastPrice) * sale.volume
          ));

          if (cryptoBuyLog[0]) {
            cryptoBuyLog[0].volume -= sale.volume;
            if (cryptoBuyLog[0].volume == 0) {
              cryptoBuyLog.shift();
            }
          }
        });

        // console.log(this.profitLog);
      });

      // reset profit log display
      this.showCryptoProfitLog.splice(0);
      for (let crypto in this.profitLog) {
        this.showCryptoProfitLog.push(false);
      }

      // create flat log for export
      let flatProfitLog = new Array<ProfitLogItem>();
      for (let crypto in this.profitLog) {
        flatProfitLog = flatProfitLog.concat(this.profitLog[crypto]);
      }

      // console.log(flatProfitLog);

      this.profitLogCsv = Papa.unparse(flatProfitLog, { delimiter: '\t' });

      this.setTotalProfit();
    },

    toggleCryptProfitLog: function(index: number) {
      Vue.set(this.showCryptoProfitLog, index, !this.showCryptoProfitLog[index]);
    },

    getCryptoProfit: function(cryptoProfitLog: ProfitLogItem[]): number {
      let profit = 0;
      cryptoProfitLog.forEach(sale => {
        profit += sale.profit;
      });
      return Math.round(profit * 100) / 100;
    },

    setTotalProfit: function() {
      this.totalCosts = 0;
      this.totalRevenue = 0;

      for (let cryptoProfitLog in this.profitLog) {
        this.profitLog[cryptoProfitLog].forEach(sale => {
          this.totalCosts += sale.buyPrice * sale.volume;
          this.totalRevenue += sale.sellPrice * sale.volume;
        })
      }

      this.totalProfit = Math.round((this.totalRevenue - this.totalCosts) * 100) / 100;
      this.totalCosts = Math.round(this.totalCosts * 100) / 100;
      this.totalRevenue = Math.round(this.totalRevenue * 100) / 100;
    },

    formatDate(date: Date): string {
      return moment(date).format('YYYY-MM-DD HH:mm');
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue